import { SelectField } from '~/common/components';
import { Col, Icon, useConfiguredForm } from '@wyz/ui';
import { LocaleUtils } from '@wyz/utils';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { useManageCriteria } from '~/common/api';
import { CriteriaHelpers } from '~/connect/helpers';
import { ICriteria, ICriteriaAwareForm } from '~/connect/types';
import { useLocale } from '~/common/context';

type CriteriaFieldProps = {
  associatedCriteriaIds: Array<ICriteria['id']>;
  onRemove: (idx: number) => void;
  name?: string;
};
const CriteriaField = ({
  associatedCriteriaIds,
  onRemove,
  name = 'criteria',
}: CriteriaFieldProps) => {
  const { locale } = useLocale();
  const methods = useFormContext<ICriteriaAwareForm>();
  const configurationContext = useConfiguredForm();
  const manageCriteria = useManageCriteria({ getAll: { enabled: true } });

  return (
    <>
      {associatedCriteriaIds.map((associatedCriterionId, criterionIdx) => {
        const fullCriterion = manageCriteria.getAll.data?.data.find(
          (item) => item.id === associatedCriterionId,
        );
        if (!fullCriterion) {
          return <Fragment key={criterionIdx} />;
        }
        return (
          <Col md={4} key={fullCriterion.id} className='position-relative'>
            <input
              type='hidden'
              {...methods.register(
                `${name}.${criterionIdx}.criterion.id` as unknown as keyof ICriteriaAwareForm,
              )}
              value={fullCriterion.id}
            />

            {configurationContext.mode !== 'READ_ONLY' && (
              <span
                className='position-absolute'
                style={{ right: 15, zIndex: 1 }}
              >
                <Icon
                  icon='trash'
                  width={'1.2rem'}
                  height={'1.2rem'}
                  role='button'
                  onClick={() => {
                    onRemove(criterionIdx);
                  }}
                />
              </span>
            )}
            <SelectField<true>
              label={fullCriterion.translatedName ?? fullCriterion.name}
              name={`${name}.${criterionIdx}.values`}
              options={CriteriaHelpers.sorterByName(fullCriterion.values).map(
                (criterionValue) => ({
                  label:
                    fullCriterion.isReserved && fullCriterion.code === 'COUNTRY'
                      ? (LocaleUtils.getHumanReadableLabel({
                          userLocale: locale,
                          locale: criterionValue.label,
                          fallback: criterionValue.label,
                          options: { type: 'region' },
                        }) as string)
                      : criterionValue.label,
                  value: criterionValue.id,
                }),
              )}
              formGroupClassName=''
              isMulti
            />
          </Col>
        );
      })}
    </>
  );
};

export default CriteriaField;
